import { createModel } from "hox";
import { TablePaginationConfig } from "antd/es/table/interface";
import { ISearchPage } from "@/types/ScmTypes";
import React, { useState, useEffect } from "react";
import {
    DEFAULT_FIRST_PAGE_NUM,
    DEFAULT_PAGE_SIZE,
} from "@/utils/constants";

import {
    IPurchaseRoSearch,
    IPurchaseRoDetail,
    IPurchaseRoFields,
} from "./purchaseRoType"
import { transPgToPagination, formatNum } from "@/utils/utils";
import { purchaseRoService } from "./purchaseRoService"
import { sourceAppOrBranch } from "@/types/VrmSaDictEnums";
import useGlobalModel from "@/model/globalModel";
import { message } from "antd";
import { convertRes2Blob } from "@/utils/exportFile";
import { roleColumnModel } from "@/utils/roleColumn";

export interface IDescTotal {
    totalNum: number,
    totalAmount: number,
    paidAmount: number,

}
export const usePurchaseRoModel = createModel(function () {
    const { shopAndOrg, setLoadingInfo } = useGlobalModel()
    const { getHideRoleColumns } = roleColumnModel();
    //切换站点清除缓存
    useEffect(() => {
        // setSelectedRowKeys([]);
        reset();
    }, [shopAndOrg.shopCode])
    const initSearchParam: IPurchaseRoSearch = {};
    const initDataSource: IPurchaseRoDetail[] = [];
    const initPgCfg: TablePaginationConfig = { pageSize: DEFAULT_PAGE_SIZE, current: DEFAULT_FIRST_PAGE_NUM }
    const initDesc = {
        totalNum: 0,
        totalAmount: 0,
        paidAmount: 0,
    }
    //查询条件
    const [searchParam, setSearchParam] = useState<IPurchaseRoSearch>(initSearchParam);
    //列表数据源
    const [dataSource, setDataSource] = useState<IPurchaseRoDetail[]>(initDataSource);
    //表格选中行Key值
    const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
    //表格选中的值
    const [selectedRow, setSelectedRow] = useState<IPurchaseRoDetail>({});
    //列表数据源分页参数

    const [pgCfg, setPgCfg] = useState<TablePaginationConfig>(initPgCfg);
    const [descTotal, setDescTotal] = useState<IDescTotal>(initDesc);
    //选中的数据统计展示的数据
    const [rowsDescTotal, setRowsDescTotal] = useState<IDescTotal>(initDesc);
    const [descRows, setDescRows] = useState<IPurchaseRoDetail[]>([]);
    const [print, setPrint] = useState<{ visible: boolean; type: string }>({
        visible: false,
        type: '1',
    });
    useEffect(() => {
        let newRowsDescTotal = initDesc
        descRows.forEach((item) => {
            let { totalNum, payableAmount, paidAmount } = item
            newRowsDescTotal.totalNum += +formatNum(totalNum)
            newRowsDescTotal.totalAmount += +formatNum(payableAmount)
            newRowsDescTotal.paidAmount += +formatNum(paidAmount)

        })
        setRowsDescTotal(newRowsDescTotal)
    }, [descRows])
    useEffect(() => {
        let filters = dataSource.filter(el => selectedRowKeys.length > 0 ? el.id === selectedRowKeys[0] : false);
        const selectedData = filters && filters.length > 0 ? filters[0] : undefined;
        setSelectedRow(selectedData as IPurchaseRoDetail)
    }, [selectedRowKeys, dataSource])

    const updatePgCfg = (updateParam: TablePaginationConfig) => {
        setPgCfg({ ...pgCfg, ...updateParam })
    }
    const updateSearchParam = (updateParam: IPurchaseRoFields) => {
        setSearchParam({ ...searchParam, ...updateParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParam);
        loadData(initPgCfg, {});
        setSelectedRowKeys([])
        setSelectedRow({})
    }
    const reset = () => {
        setSearchParam(initSearchParam);
        setSelectedRowKeys([])
        setSelectedRow({})
    }
    const loadData = async (page?: ISearchPage, searchValue: IPurchaseRoSearch = searchParam) => {
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            ...sourceAppOrBranch,
            pageSize: page?.pageSize ?? pgCfg.pageSize ?? DEFAULT_PAGE_SIZE,
            pageNum: (page?.pageNum || page?.current) ?? pgCfg.current ?? DEFAULT_FIRST_PAGE_NUM,
        }
        let { retData } = await purchaseRoService.page(searchParams);
        const { records, ...pg } = retData
        setPgCfg(transPgToPagination(pg));
        setDataSource(records);
        loadTotal(searchParams);

    }
    const loadTotal = async (searchParams: any) => {
        let { retData: statistics } = await purchaseRoService.total(searchParams);
        setDescTotal(statistics)
    }
    const invalidate = async (cancelReason: string) => {
        let { id, returnCode } = selectedRow
        let { retData } = await purchaseRoService.invalidate({ id, returnCode, cancelReason });
        if (retData) {
            loadData()
            message.success("作废成功")
        }
    }
    const exportPurchaseRo = async (searchValue: IPurchaseRoSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            id: selectedRowKeys.join(),
            hidden: getHideRoleColumns("purchaseReturn", "主单"),
        }
        try {
            let result = await purchaseRoService.export(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    const detailsExport = async (searchValue: IPurchaseRoSearch = searchParam) => {
        setLoadingInfo({ loadingVisible: true, txt: "快速导出中" })
        const shopParam = {
            shopType: searchValue.shopId !== undefined ? 1 : shopAndOrg.shopType,
            shopId: searchValue.shopId ?? shopAndOrg.shopId
        };
        const searchParams = {
            ...searchValue,
            ...shopParam,
            id: selectedRowKeys.join(),
            hidden: getHideRoleColumns("purchaseReturn", "明细"),
        }
        try {
            let result = await purchaseRoService.detailsExport(searchParams);
            result && setLoadingInfo({ loadingVisible: false, txt: "" });
            convertRes2Blob(result)
        } catch (error) {
            setLoadingInfo({ loadingVisible: false, txt: "" });
        }

    }
    return {
        /***field***/
        searchParam,
        dataSource,
        selectedRowKeys,
        pgCfg,
        initPgCfg,
        descTotal,
        selectedRow,
        /***method***/
        setDataSource,
        setSelectedRowKeys,
        resetSearchParam,
        updateSearchParam,
        loadData,
        updatePgCfg,
        setDescTotal,
        setSelectedRow,
        invalidate,
        exportPurchaseRo,
        detailsExport,
        rowsDescTotal, setRowsDescTotal,
        descRows, setDescRows,
        reset,
        print, setPrint
    }
});